import React, { FC } from 'react';
import { Image } from '@funtech-int/kp-graphql-sdk/yango-movies-www';
import { createPictureFactory, Picture } from '@funtech-int/yango-shared';

import styles from './_PurchaseBadge.module.css';

const pictureFactory = createPictureFactory({
    fallback: {
        srcSet: {
            '1x': 'x48',
            '2x': 'x80',
        },
        src: 'x48',
    },
});

interface FavoriteBadgeProps {
    ariaLabel: string;
    badge?: Image | null;
}

export const PurchaseBadge: FC<FavoriteBadgeProps> = ({ ariaLabel, badge }) => {
    const { img } = pictureFactory({
        fallbackUrl: badge?.toString(),
    });

    return (
        <Picture
            className={styles.root}
            alt={ariaLabel}
            aria-label={ariaLabel}
            loading="lazy"
            srcSet={img.srcSet}
            src={img.src}
            data-tid="AdaptiveImage"
        />
    );
};
